module.exports = __webpack_public_path__ + "img/sb.c31765df.jpg";